export const TRIGGER_COUNT_METRIC = 'metrics/TRIGGER_COUNT_METRIC';
export const CAPTURE_LCP = 'metrics/CAPTURE_LCP';
